export default {
    filesSelect: {
        files: "Files",
        download: "Download",
        moreThanOneSignificantFile: "More than one significant file, autoloading will not work",
    },
    multiTaskPresets: {
        presets: "Presets",
        saveAs: "Save As",
        edit: "Edit",
        delete: "Delete",
        apply: "Apply",
        enterPresetName: "Enter the name of the preset",
        cancellation: "Cancel",
        dataForPresetNotSelected: "No data selected for preset",
        presetWithThisNameAlredyExist: "A preset with the same name already exists",
        selectedNewElements: "Are new elements selected?",
        deleteSelectedPreset: "Delete selected preset?",
    },
    resultLogButton: {
        result: "Result"
    },
    runTaskForm: {
        close: "Close",
        cancel: "Cancel",
        start: "Start",
        accept: "Confirm",
        fileSelect: "Select file",
        dataBase: "Database",
        fileSelect: "Select file",
        comment: "Comment",
        cmdLine: "cmdLine:",
        taskStarted: "Task started",
        taskCompleted: "Task completed",
        withError: "with error",
        taskHelp: "Task Help",
        launchOnAllBases: "Launch on all bases",
        fileMustBePresent: "File must be present",
        inappropriateNumberFormat: "Inappropriate number format in line number",
        inappropriateFloatFormat: "Inappropriate floating point format in line number",
        allFieldsMustBeEntered: "All fields must be entered",
        checkFieldsContent: "Check the content of the fields!",
        oneOrAllFieldsNotFilled: "One or more fields are empty",
        noAppTypeInFileName: "No application type found in file name, accepted as admin",
        uncorrectFileForAppRefresh: "Invalid update file for the current application",
        plsRefreshPage: "Please refresh the page",
        noHelpOnThisTaskCtrlEnter: "There is no help for this task. Ctrl + Enter to start the task"
    },
    statusGrid: {
        files: "Files",
        download: "Download",
        watchLog: "Watch log",
        delete: "Delete",
        deleteSelected: "Delete selected",
        restore: "Restore",
        emptyTrash: "Empty Trash",
        zombies: {
            emergency: "Emergency situation",
            clearZombies: "Clear hanging tasks",
            withHttp: 'Clear on unresponsive servers',
            withoutHttp: "Don't clear on unresponsive servers",
            noTasksNoProblems: "No tasks cleared, no problems found",
            tasksCleared: "Cleared {number} tasks",
            tasksAndZombies: "Cleared tasks: {number}, zombies found: {zombie}",
            zombies: "Zombies found: {zombie}",
            noTasksCleared: "No tasks cleared",
            errorsOnServers: "Found errors from servers",
            warningsServers: "Warnings from servers:",
            tasksInfo: "These tasks info is in Task status — Finished tasks, field Comment",
            goToAdmin: "Please inform developers (Linux consultant) to close zombies and free resources"
        },
        view: "View",
        compact: "Optimal",
        full: "Full",
        refresh: "Refresh",
        leaveInLast: "Leave for the last",
        days: "days",
        completed: "completed",
        stated: "running",
        thisActionRemoveAllToTrash: "This action will move everything to the trash",
        tasksAfter: "tasks after",
        daysFromToday: "day (-s) from today",
        attention: "Attention",
        cancellation: "Cancel",
        uncorrectNumberOfDays: "The number of days is incorrect",
        willRemove: "remove selected",
        willRestore: "restore selected",
        willCleanse: "clear selected",
        thisAction: "This action will {action} {task}. Continue?",
        thisTask: "task | tasks",
        continue: "Continue",
        cancel: "Back",
        thisActionCleanseAllRemovedTasks: "This action will clear all deleted tasks",
        thisActionCleanseSelectedRemovedTasks: "This action will clear selected deleted task. Continue? | This action will clear selected deleted tasks. Continue?"
    },
    taskStatus: {
        completedTaskResult: "Completed task results",
        taskStarted: "task started",
        taskCompleted: "task completed",
        timeoutExceeded: "timeout exceeded",
        taskTerminatedAbnormally: "task terminated abnormally",
        taskInProcess: "This task is in progress",
        thisTaskTimedOut: "This task has timed out the web page",
    }
}